import { render, staticRenderFns } from "./nick.vue?vue&type=template&id=0fc5b659&"
import script from "./nick.vue?vue&type=script&lang=js&"
export * from "./nick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports